const StatusBadge: React.FC<{ status: string; colorCode?: string }> = ({ status, colorCode }) => {
    const colorStyle = colorCode
        ? { backgroundColor: `${colorCode}20`, color: colorCode }
        : { backgroundColor: '#e5e7eb', color: '#374151' };

    return (
        <span className="px-3 py-1 text-xs font-medium rounded-full" style={colorStyle}>
            {status}
        </span>
    );
};

export default StatusBadge;